export const SET_DISPLAY_ID_AND_GET_TOKENS_DATA_REQUEST = 'SET_DISPLAY_ID_AND_GET_TOKENS_DATA_REQUEST';
export const SET_DISPLAY_ID_AND_GET_TOKENS_DATA_RESPONSE = 'SET_DISPLAY_ID_AND_GET_TOKENS_DATA_RESPONSE';
export const SET_ALERT_DATA_REQUEST = 'SET_ALERT_DATA_REQUEST';
export const SET_ALERT_DATA_RESPONSE = 'SET_ALERT_DATA_RESPONSE';
export const ALERT_SUSPEND = 'ALERT_SUSPEND';
export const SET_ALERT = 'SET_ALERT';
export const GET_TOKENS_DATA_WITH_SOCKET_REQUEST = 'GET_TOKENS_DATA_WITH_SOCKET_REQUEST';
export const SOCKET_INTIATE = 'SOCKET_INTIATE';